import { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export default function ContractService() {
  const [openContract, setOpenContract] = useState(false);
  const [employeeContract, setEmployeeContract] = useState([]);
  const [contractPdf, setContractPdf] = useState("");
  const [employeeEmail, setEmployeeEmail] = useState("");
  const [empId, setEmpId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);

  const handleContractCancel = () => {
    setOpenContract(false);
  };

  const showcontractModal = (employeeId, email, status) => {
    try {
      axiosInstance
        .get(API.hiringContracts.getReceiveContractByApplicant(employeeId))
        .then((response) => {
          const responseData = response.data;
          setEmployeeContract(responseData);
          setOpenContract(true);
          setEmployeeEmail(email);
          setEmpId(employeeId);
          setSelectedStatus(status);
        })
        .catch((error) => {
          console.error("Error fetching contract data:", error);
        });
    } catch (error) {
      console.error("Error fetching contract data:", error);
    }
  };

  const handleContractPreview = async (fileUrl) => {
    try {
      // Get the file extension
      const extension = fileUrl.split(".").pop().toLowerCase();

      if (extension === "pdf") {
        // If PDF, set the selected PDF state and open modal for preview
        setContractPdf(fileUrl);
        const modal = new bootstrap.Modal(document.getElementById("staticBackdropc"));
        modal.show();
      } else {
        // If not PDF, download the file
        window.open(fileUrl, "_blank");
      }
    } catch (error) {
      console.error("Error handling file:", error);
    }
  };

  return {
    openContract,
    employeeContract,
    contractPdf,
    handleContractCancel,
    showcontractModal,
    handleContractPreview,
    employeeEmail,
    empId,
    selectedStatus,
  };
}
